import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { BonusAvailable } from '@user/const';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getBonusBalanceState: MemoizedSelector<
  StateWithCustomUser,
  StateUtils.LoaderState<BonusAvailable>
> = createSelector(getCustomUserState, (state: CustomUserState) => state.bonusBalance);

export const getBonusBalanceError: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getBonusBalanceState,
  (state: StateUtils.LoaderState<BonusAvailable>) => StateUtils.loaderErrorSelector(state),
);

export const getBonusBalanceSuccess: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getBonusBalanceState,
  (state: StateUtils.LoaderState<BonusAvailable>) => StateUtils.loaderSuccessSelector(state),
);

export const getBonusBalanceValue: MemoizedSelector<StateWithCustomUser, BonusAvailable> = createSelector(
  getBonusBalanceState,
  (state: StateUtils.LoaderState<BonusAvailable>) => StateUtils.loaderValueSelector(state),
);
export const getBonusBalanceLoading: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getBonusBalanceState,
  (state: StateUtils.LoaderState<BonusAvailable>) => StateUtils.loaderLoadingSelector(state),
);
